import React from "react";
import { New_ScrollX2025 } from "../../../assets/icons";

const Navbar = ({
  isSearchOpen,
  setIsSearchOpen,
  isMenuOpen,
  setIsMenuOpen,
  onHome,
  onSupport,
}) => {
  return (
    <header className="topbar">
      <button
        className="icon-button menu-button"
        type="button"
        aria-label="Open help navigation"
        aria-expanded={Boolean(isMenuOpen)}
        onClick={() => setIsMenuOpen?.((open) => !open)}
      >
        ☰
      </button>
      <button
        className="brand"
        type="button"
        onClick={onHome}
        aria-label="ScrollX Help Center home"
      >
        <img className="brand-mark" src={New_ScrollX2025} alt="" width="34" height="34" />
        <span>ScrollX <small>Help Center</small></span>
      </button>
      <div className="header-actions">
        <button
          className="search-trigger"
          type="button"
          aria-haspopup="dialog"
          aria-expanded={Boolean(isSearchOpen)}
          onClick={() => setIsSearchOpen(!isSearchOpen)}
        >
          <span aria-hidden="true">⌕</span>
          <span>Search help</span>
          <span className="key">Ctrl K</span>
        </button>
        <button
          className="icon-button"
          type="button"
          aria-label="Contact support"
          onClick={onSupport}
        >
          ?
        </button>
      </div>
    </header>
  );
};

export default Navbar;
